import type { MenuCategory, MenuItem } from '../types/workspace';

export type PublicMenuSection = {
  id: string;
  title: string;
  shortDescription: string;
  coverImage: string;
  items: MenuItem[];
};

/** Expects categories and items already limited to public visibility (e.g. from SiteWorkspaceContext). */
export const buildPublicMenuSections = (categories: MenuCategory[], items: MenuItem[]): PublicMenuSection[] => {
  const sortedCategories = [...categories].sort((left, right) => left.sortOrder - right.sortOrder);

  return sortedCategories.map((category) => ({
    id: category.id,
    title: category.title,
    shortDescription: category.shortDescription,
    coverImage: category.coverImage,
    items: [...items]
      .filter((item) => item.categoryId === category.id)
      .sort((left, right) => left.sortOrder - right.sortOrder),
  }));
};

export const flattenPublicItemsInSectionOrder = (sections: PublicMenuSection[]): MenuItem[] =>
  sections.flatMap((section) => section.items);
